"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var button_component_1 = require("@cian/button-component");
var utils_1 = require("@cian/utils");
var cookie_1 = require("@cian/utils/lib/browser/cookie");
var favorite_network_1 = require("../../browser/utils/favorite_network");
var icon_1 = require("./icon");
var motivation_popup_1 = require("./motivation_popup");
var state_1 = require("./state");
var tracking_1 = require("./tracking");
var styles = require("./index.css");
var MOTIVATION_COOKIE_NAME = 'newbuilding-favorite_motivation';
var FavoriteButton = /** @class */ (function (_super) {
    tslib_1.__extends(FavoriteButton, _super);
    function FavoriteButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCloseMotivation = function () {
            _this.props.setMotivationPopupVisible(false);
            tracking_1.trackMotivationClose();
        };
        _this.handleLogin = function () {
            var _a = _this.props, setMotivationPopupVisible = _a.setMotivationPopupVisible, showLoginPopup = _a.showLoginPopup;
            setMotivationPopupVisible(false);
            showLoginPopup();
            tracking_1.trackMotivationLoginClick();
        };
        _this.handleRegister = function () {
            _this.props.setMotivationPopupVisible(false);
            window.location.href = '/registration/';
        };
        _this.handleToggleFavorite = function () {
            // tslint:disable:no-any
            var updateHeaderFavoritesCount = window.__updateHeaderFavoritesCount || (function () { });
            var getHeaderFavoritesCount = window.__getHeaderFavoritesCount || (function () { });
            // tslint:enable:no-any
            var _a = _this.props, apiBaseUrl = _a.apiBaseUrl, isActive = _a.isActive, newbuildingId = _a.newbuildingId, pageType = _a.pageType, customPageUrl = _a.customPageUrl, toggleFavorite = _a.toggleFavorite, userIsAuthenticated = _a.userIsAuthenticated, showLoginPopup = _a.showLoginPopup, setMotivationPopupVisible = _a.setMotivationPopupVisible;
            var toggle = function (state) {
                toggleFavorite();
                updateHeaderFavoritesCount(state);
            };
            var newIsActive = !isActive;
            var currentFavoritesCount = getHeaderFavoritesCount();
            if (newIsActive && !userIsAuthenticated && currentFavoritesCount >= 5) {
                showLoginPopup();
            }
            else {
                toggle(newIsActive);
                var cookies = utils_1.parseCookies(document.cookie);
                if (newIsActive && !cookies[MOTIVATION_COOKIE_NAME] && !userIsAuthenticated && currentFavoritesCount === 0) {
                    setMotivationPopupVisible(true);
                    tracking_1.trackMotivationShow(customPageUrl);
                    cookie_1.setCookie(MOTIVATION_COOKIE_NAME, '1', {
                        domain: '.cian.ru',
                        expires: 24 * 60 * 60,
                        secure: false,
                    });
                }
                if (newIsActive) {
                    favorite_network_1.addNewbuildingToFavorites(apiBaseUrl, newbuildingId).catch(function () { return toggle(false); });
                    tracking_1.trackAddNewbuildingToFavorites(newbuildingId, customPageUrl, pageType);
                }
                else {
                    favorite_network_1.removeNewbuildingFromFavorites(apiBaseUrl, newbuildingId).catch(function () { return toggle(true); });
                    tracking_1.trackRemoveNewbuildingFromFavorites(newbuildingId, customPageUrl, pageType);
                }
            }
        };
        return _this;
    }
    FavoriteButton.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, withoutText = _a.withoutText, withoutMotivation = _a.withoutMotivation, motivationIsVisible = _a.motivationIsVisible;
        return (React.createElement("div", { className: styles['container'] },
            React.createElement(button_component_1.Button, tslib_1.__assign({}, utils_1.mergeStyles(styles['button'], withoutText && styles['button-without-text']), { theme: button_component_1.ButtonTheme.Ghost, onClick: this.handleToggleFavorite }),
                React.createElement(icon_1.Icon, { isActive: isActive }),
                withoutText ? null : (isActive ? 'В избранном' : 'В избранное')),
            !withoutMotivation &&
                React.createElement(motivation_popup_1.MotivationPopup, { isVisible: motivationIsVisible, onCloseClick: this.handleCloseMotivation, onLoginClick: this.handleLogin, onRegisterClick: this.handleRegister })));
    };
    return FavoriteButton;
}(React.Component));
exports.FavoriteButtonContainer = react_redux_1.connect(function (state) { return ({
    isActive: state.isActive,
    motivationIsVisible: state.motivationIsVisible,
}); }, function (dispatch) { return ({
    setMotivationPopupVisible: function (isVisible) { return dispatch(state_1.setMotivationPopupVisibleAction(isVisible)); },
    toggleFavorite: function () { return dispatch(state_1.toggleFavoriteAction()); },
}); })(FavoriteButton);



//////////////////
// WEBPACK FOOTER
// ./src/shared/favorite_button/index.tsx
// module id = 297
// module chunks = 2